import React from "react";

import ErrorBoundary from "../components/ErrorBoundary";
import MainRouter from "./Router";

const App: React.FC = () => (
  <ErrorBoundary>
    <MainRouter />
  </ErrorBoundary>
);

export default App;
